import type { IconProps } from './IconProps';

export const CloseSmallIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 18}
    height={props.height ?? 18}
    {...props}
  >
    <path
      d="M5.09662 3.90338C4.76712 3.57387 4.23288 3.57387 3.90338 3.90338C3.57387 4.23288 3.57387 4.76712 3.90338 5.09662L7.80676 9L3.90338 12.9034C3.57387 13.2329 3.57387 13.7671 3.90338 14.0966C4.23288 14.4261 4.76712 14.4261 5.09662 14.0966L9 10.1932L12.9034 14.0966C13.2329 14.4261 13.7671 14.4261 14.0966 14.0966C14.4261 13.7671 14.4261 13.2329 14.0966 12.9034L10.1932 9L14.0966 5.09662C14.4261 4.76712 14.4261 4.23288 14.0966 3.90338C13.7671 3.57387 13.2329 3.57387 12.9034 3.90338L9 7.80676L5.09662 3.90338Z"
      fill="#9294A6"
    />
  </svg>
);
